export default function MrlFooter(){
    return(
        <footer className="mrl-footer shadow" style={{backgroundColor:'#ffffff'}}>
            <div className="container-fluid d-flex justify-content-center align-items-center ps-3 pe-3 pt-3 pb-3">
                <div className='me-3'>
                    <img
                            src="https://www.mattiamerlini.it/image/logo/logo.png"
                            alt="Mattia Merlini"
                            loading="lazy"
                            width="117" height="35"
                    />
                </div>
                <div className='footer-contact ms-3'>
                    Merlini Mattia Impresa Individuale | Via Cavour 4, 25030 Erbusco (BS)<br/>
                    P.Iva: 03717040988 C.F.: MRLMTT95E29B157J REA: BS-597198<br/>
                    Email: info@mattiamerlini.it Telefono: +39 3515034624 Website: www.mattiamerlini.it
                </div>
            </div>
        </footer>
    );
}